import { createFeatureSelector, createSelector, on } from '@ngrx/store';
import { IntegrationsState } from '../models/integrations-state.model';
import { OptionType } from 'src/app/core/enums/enums';

export const selectIntegrations = createFeatureSelector<IntegrationsState>(OptionType.Integrations);

export const selectLoading = createSelector(
  selectIntegrations,
  (state: IntegrationsState) => state.loading
);

export const selectCurrentProcess = createSelector(
  selectIntegrations,
  (state: IntegrationsState) => state.currentProcess
);
